import { AppState } from '@/types/AppState.types';
import { AuthenticationState } from '@/types/AuthenticationState.types';

export const selectAuthState = (state: AppState): AuthenticationState =>
  state.user.status;

export const selectUsername = (state: AppState) => state.user.details?.username;

export const selectUserDetails = (state: AppState) => state.user.details;

export const selectUserIsAuthenticated = (state: AppState) =>
  state.user.status.authenticated;

export const selectBearerToken = (state: AppState) =>
  state.user.status.clientCredentials?.bearerToken;
